import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default function OrderInfo(props) {
    const classes = useStyles();

    const rows = [
        createData('Article', props.productionOrder.bomOut[0].productName),
        createData('Pieces', props.productionOrder.bomOut[0].quantityToProduce),
        createData('Colour', JSON.parse(props.productionOrder.metaData).find(x => x.MetaDataType === 1).MetaData[0]),
    ];

    function createData(name, info) {

        if (name === 'Colour') {
            info = "<b>Cover: </b>" + info.CoverColor +" , <b>Body: </b>" + info.BodyColor + " , <b>Lens: </b>" + info.LensColor;
        }

        return { name, info };
    }

    return <div className={classes.orderInfo}>

        <div className={classes.orderno}>
            Ordern°
        </div>
        <div className={classes.orderNumber}>
            {props.productionOrder.reference}
        </div>
        <div className={classes.orderTable}>

        </div>
        <TableContainer component={Paper} className={classes.paper}>
            <Table className={classes.table} aria-label="customized table">
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.name} className={classes.row}>
                            <TableCell className={classes.nameCell}>
                                {row.name}
                            </TableCell>
                            <TableCell className={classes.infoCell}><div dangerouslySetInnerHTML={{__html: row.info}}></div></TableCell>

                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    </div>
}

const useStyles = makeStyles({
    orderInfo: {
        height: "150px",
        float: "left",
        paddingLeft: "30px",
        width: "calc(100% - 200px)"
    },
    orderno: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
        marginTop: "15px"
    },
    orderNumber: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: "block",
        marginBottom: "10px"
    },
    orderTable: {
        display: "block"
    },
    nameCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "100px"
    },
    infoCell: {
        padding: "3px !important",
        border: "none",
        fontSize: "14",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
    },
    paper: {
        boxShadow: 'none'
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: "#F4F4F4",
        },
    }
});